import {E, GetEntries} from "js-vextensions";
import {observer_mgl} from "mobx-graphlink";
import React from "react";
import {Button, Column, Row, Select, TextInput} from "react-vcomponents";
import {RunInAction_Set} from "web-vcore";
import {store} from "../../../Store/index.js";
import {TestingTab} from "../../../Store/main/testing.js";
import {nativeBridge} from "../../../Utils/Bridge/Bridge_Native.js";
import {GetNavBarHeights} from "../../Root.js";
import {BridgesTab} from "./TestingPanel/BridgesTab.js";
import {EyeMoveDetectionTab} from "./TestingPanel/EyeMoveDetectionTab.js";
import {LightmapSettingsUI} from "./TestingPanel/LightmapSettingsUI.js";
import {SessionTab} from "./TestingPanel/SessionTab.js";
import {MobXTab} from "./TestingPanel/MobXTab.js";

export const TestingPanel = observer_mgl(()=>{
	const uiState = store.main.testing;

	const page_leftMarginWidth = (window.innerWidth - 960) / 2;
	const pageWideEnoughToFitPanelInLeftMargin = page_leftMarginWidth >= 400;
	const width = uiState.expanded || !pageWideEnoughToFitPanelInLeftMargin
		? "100%"
		: "calc(((100% - 960px) / 2) - 10px)";

	return (
		<Column style={E(
			{position: "fixed", zIndex: 12, width, height: `calc(100% - ${GetNavBarHeights()}px)`, padding: 5, background: "rgba(0,0,0,.9)", borderRadius: "0 0 0 5px"},
			store.main.topLeftOpenPanel != "testing" && {display: "none"},
		)}>
			<Row>
				<Select options={GetEntries(TestingTab, "ui")} displayType="button bar" value={uiState.tab} onChange={val=>RunInAction_Set(()=>uiState.tab = val)}/>
				<Button ml="auto" faIcon="arrows-alt-h" onClick={()=>RunInAction_Set(()=>uiState.expanded = !uiState.expanded)}/>
			</Row>
			{uiState.tab == TestingTab.general && <GeneralTab/>}
			{uiState.tab == TestingTab.session && <SessionTab/>}
			{uiState.tab == TestingTab.eyeMove && <EyeMoveDetectionTab/>}
			{uiState.tab == TestingTab.bridges && <BridgesTab/>}
			{uiState.tab == TestingTab.mobX && <MobXTab/>}
		</Column>
	);
});

const GeneralTab = observer_mgl(()=>{
	const uiState = store.main.testing;
	return (
		<Column>
			<Row mt={5}>
				<TextInput value={uiState.errorMessage} onChange={val=>RunInAction_Set(()=>uiState.errorMessage = val)} style={{flex: 1}}/>
				<Button ml={5} text="Throw error" onClick={()=>{
					//throw new Error(uiState.errorMessage);
					nativeBridge.Call("TriggerError", uiState.errorMessage);
				}}/>
			</Row>
			<LightmapSettingsUI/>
		</Column>
	);
});